// Classes.
import { CategoryLocatorComponent } from "../../locators/category.locator-component";

// Structs.
import { IdLabelStruct } from "../../util/id-label.struct";

// Services.
import { FactoryService } from "../../wa-services/factory-service";

// Interfaces
import { RecordItemInterface } from "../../interfaces/record-item.interface";

export abstract class RecordBaseItem implements RecordItemInterface {
  static readonly typeOlympic = new IdLabelStruct("or", "Olympic record");
  static readonly typeParalympic = new IdLabelStruct("pr", "Paralympic record");
  static readonly typeWorld = new IdLabelStruct("wr", "World record");

  public levelId: number;
  public disciplineId: number;
  public areaId: number;
  public name: string;
  public subname: string;
  public date: Date;
  public noc: string;
  public points: number;
  public xs: number;
  public prevPoints: number;
  public prevXs: number;
  public maxPoints: number;
  public para: boolean;
  public typeId: number;
  public competition: {
    id: number;
    country: string;
    name: string;
    place: string;
  } = {} as any;
  protected _category: CategoryLocatorComponent;
  protected recordsDetail: any;
  protected _completeName: string;
  protected _isOlympic: boolean = false;
  protected _isParalympic: boolean = false;
  protected _isWorld: boolean = false;
  protected _isTeam: boolean;
  protected _type: IdLabelStruct;
  teamName: string;

  public constructor(rawRecordItem: any, protected factory: FactoryService) {
    this.levelId = rawRecordItem.RecordLevelId;
    this.typeId = rawRecordItem.RecordTypeId;
    this.disciplineId = rawRecordItem.RecordDiscipline;
    this.areaId = rawRecordItem.RecordArea;
    this.name = rawRecordItem.RecordName;
    this.subname = rawRecordItem.RecordSubName;
    this.date = new Date(
      new Date(
        new Date(rawRecordItem.Date).getTime() +
          Math.abs(new Date(rawRecordItem.Date).getTimezoneOffset() * 60000)
      )
    );
    this.noc = rawRecordItem.NOC;
    this._isTeam = !!rawRecordItem.Team;
    this.points = rawRecordItem.Points;
    this.xs = rawRecordItem.Xs;
    this.prevPoints = rawRecordItem.OldPoints;
    this.prevXs = rawRecordItem.OldXs;
    this.maxPoints = rawRecordItem.MaxPoints;
    this.para = rawRecordItem.ParaAr;
    this.competition.id = rawRecordItem.Competition.ID;
    this.competition.name = rawRecordItem.Competition.Name;
    this.competition.place = rawRecordItem.Competition.Place;
    this.competition.country = rawRecordItem.Competition.Country;
    this.teamName = rawRecordItem.Team;
    // Set category.
    this._category = new CategoryLocatorComponent();
    this._category.catCode = rawRecordItem.Cat;

    this.setCompleteName();
    this.setLevel();
  }

  public get catId(): number {
    return this._category.catId;
  }

  public get catCode(): string {
    return this._category.catCode;
  }

  public get isTeam(): boolean {
    return this._isTeam;
  }

  public abstract getLabel(): string;

  public abstract getPicture(): string;

  public abstract getSubjectId(): any;

  protected setCompleteName() {
    if (this.subname) {
      this._completeName = `${this.name} - ${this.subname}`;
    } else {
      this._completeName = this.name;
    }
  }

  protected setLevel() {
    switch (this.levelId) {
      case 1:
        this._isOlympic = !this.para;
        this._isParalympic = this.para;
        if (this._isOlympic) {
          this._type = RecordBaseItem.typeOlympic;
        } else {
          this._type = RecordBaseItem.typeParalympic;
        }
        break;

      case 2:
        this._isWorld = true;
        this._type = RecordBaseItem.typeWorld;
        break;
    }
  }

  public getCompleteName(): string {
    return this._completeName;
  }

  public get isOlympic(): boolean {
    return this._isOlympic;
  }

  public get isParaolympic(): boolean {
    return this._isParalympic;
  }

  public get isWorld(): boolean {
    return this._isWorld;
  }

  public getType(): IdLabelStruct {
    return this._type;
  }
}
